export const getLastId = collection =>
  collection.reduce(
    (maxId, element) => (maxId > element.id ? maxId : element.id),
    0
  );
